import {
	setSelectedColor,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { ColorPickerInputs } from '../ColorPickerInputs';
import {
	StyledColorPicker,
	StyledColorPickerContainer,
} from './ColorPicker.styled';

const ColorPicker = (props: React.HtmlHTMLAttributes<HTMLDivElement>) => {
	const dispatch = useLayoutDispatch();
	const selectedColor = useLayoutSelector(
		(state) => state.colorPicker.selectedColor,
	);

	return (
		<StyledColorPickerContainer {...props}>
			<StyledColorPicker
				color={selectedColor}
				onChange={(rgbColor) => dispatch(setSelectedColor(rgbColor))}
			/>
			<ColorPickerInputs />
		</StyledColorPickerContainer>
	);
};

export { ColorPicker };
